import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

interface FilterBarState {
  searchText: string;
}

class FilterBar extends Component<FilterBarState> {
  // TODO - document events in design-system/src/docs/components.js
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      actions: {type: `json`, description: `Array of ActionOption to show when items are selected`, default: []},
      filters: {type: `json`, description: `Array of options to display as filter dropdowns`, default: []},
      'result-count': {type: `string`, description: `Number of results`},
      'selected-count': {type: `number`, description: `Number of selected items`},
      'search-placeholder': {type: `string`, description: `Placeholder text for empty search`, default: `Search`},
      'search-text': {type: `string`, description: `Search input text`},
    };
  }
  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        searchText: ``,
      },
      helpers: {
        getLabelList: (filterOption) => filterOption.options.map((option) => option.label),

        getSelectedLabel: (filterOption) => {
          const selected = filterOption.options.find((option) => option.selected);
          return selected ? selected.label : `Select ${filterOption.name}`;
        },

        handleClickAction: (eventName) =>
          this.dispatchEvent(new CustomEvent(`clickAction`, {detail: {name: eventName}})),

        handleClearSelected: () => this.dispatchEvent(new CustomEvent(`clearSelected`)),

        handleFilterChange: (ev, filterName) =>
          this.dispatchEvent(
            new CustomEvent(`changeFilter`, {
              detail: {
                ...ev.detail,
                name: filterName,
              },
            }),
          ),

        handleFilterReset: () =>
          this.attr(`filters`).forEach((filter) => {
            if (filter.noFilterLabel) {
              this.config.helpers.handleFilterChange({detail: {value: filter.noFilterLabel}}, filter.name);
            }
          }),

        isFilterSectionHidden: () => this.attr(`filters`).every((f) => !f.options.length),

        isFilterSelected: () =>
          this.attr(`filters`).some((filter) =>
            filter.options.some(
              (option) => filter.noFilterLabel && option.label !== filter.noFilterLabel && option.selected,
            ),
          ),

        handleUpdateInput: (ev) => {
          this.update({searchText: ev.target.value});
          this.dispatchEvent(
            new CustomEvent(`updateInput`, {
              detail: {
                value: ev.target.value,
              },
            }),
          );
        },
      },
    };
  }

  public attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);

    // support updating searchText via attr as well
    if (attr === `search-text`) {
      this.update({searchText: this.attr(attr)});
    }
  }
}

registerMPElement(`mp-filter-bar`, FilterBar);
